<template>
  <div v-bind="$attrs" v-resize="recalcWidthHeight" class="box-container ma-0 pa-0" :style="`width: ${wi}; height: ${he}; max-height: ${maxHeight};`">
    <div v-if="slotHeight" class="row-header ma-0 pa-0 my-2" :style="'width: 100%; height: ' + slotHeight + 'px'">
      <slot name="top"> </slot>
    </div>
    <div v-if="showFilters" class="row-header ma-0 pa-0 my-1" :style="'width: 100%; height: ' + filtersHeight + 'px'">
      <v-text-field
        class="subtitle-2"
        align-items="center"
        variant="outlined"
        :label="s_SearchSort"
        v-model="filterText"
        hide-details
        density="compact"
        @input="filterChanged"
        @keyup.enter="filterChanged"
      >
        <template v-slot:append>
          <v-tooltip :disabled="hideTooltips" location="right">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" style="cursor: pointer">mdi-sort</v-icon>
              <v-menu activator="parent">
                <v-list class="ma-0 pa-0">
                  <v-list-item
                    v-for="sort in devsSortTypes"
                    :key="sort.id"
                    style="cursor: pointer"
                    :style="sort.name == devsSortType ? 'background-color: ' + Colors.MenuColor : ''"
                  >
                    <v-list-item-title class="ma-0 pa-0 caption" @click="devsSortType = sort.name">{{ sort.name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <span>{{ "Сортиране: " + devsSortType }}</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </div>
    <!-- <div v-if="showFilters" class="row-header ma-0 pa-0 mb-1" :style="'width: 100%; height: ' + 1 + 'px'">
      <t-divider class="ma-0 mb-2 pa-0"></t-divider>
    </div> -->

    <div v-if="showAll" class="row-header ma-0 pa-0" :style="'width: 100%; height: ' + getButtonsHeight + 'px'">
      <v-tooltip :disabled="hideTooltips" location="right">
        <template v-slot:activator="{ props }">
          <v-card
            v-bind="props"
            class="ma-0 pa-0"
            width="100%"
            variant="outlined"
            rounded
            :height="getButtonsHeight - 2"
            @click.stop="itemClick(undefined)"
            :style="!lastItem ? 'background: ' + Colors.ActiveItemBackground : ''"
          >
            <v-row class="ma-0 mx-3 pa-0" justify="start" align="center" :style="`width: ${width}px; height: 100%`">
              <!-- <v-btn class="ma-0 pa-0" text style="pointer-events: none; width: 100%"> -->
              <!-- <v-icon class="mx-2" small v-if="item.Status" :color="item.Status.Color">{{ item.Status.Icon }}</v-icon> -->
              <span class="subtitle-2">{{ s_AllDevices }}</span>
              <!-- </v-btn> -->
            </v-row>
          </v-card>
        </template>
        {{ s_DeviceList_ChooseAllDevs }}
      </v-tooltip>
    </div>
    <div class="row-content ma-0 pa-0" ref="refDeviceListContainer">
      <div style="visibility: hidden; height: 1px; width: 1px"></div>
      <v-virtual-scroll
        v-if="getItems && getItems.length > 0"
        ref="refVirtualScroller"
        :style="'left: 0; right: 0; bottom: 0; top: auto;'"
        :items="getItems"
        :height="virtualScrollerHeight"
        :width="wi"
        :item-height="getButtonsHeight"
        style="overflow-x: hidden"
      >
        <template v-slot:default="{ item }">
          <v-tooltip :disabled="hideTooltips" :open-on-click="false" location="right">
            <template v-slot:activator="{ props }">
              <v-card
                v-bind="props"
                class="ma-0 mb-1 pa-0"
                width="100%"
                variant="outlined"
                :rounded="true"
                :height="getButtonsHeight - 6"
                @click.stop="itemClick(item)"
                :class="IF.MyFont + ' ' + getString(item.Status)"
                :style="isSelected(item) ? 'background: ' + Colors.ActiveItemBackground : ''"
              >
                <v-row class="ma-0 mx-2 pa-0" align="center" justify="start" :style="`width: ${width}px; height: 100%;`">
                  <v-img v-if="!!item.Image" :src="item.Image" :max-width="50" :height="60"> </v-img>
                  <span class="caption">{{ item.name }}</span>
                </v-row>
              </v-card>
            </template>
            <span style="white-space: pre">{{ item.name + "\n" + item.id + "\n" + item.fd.sn }}</span>
            <!-- TODO item address ? -->
          </v-tooltip>
        </template>
      </v-virtual-scroll>
      <v-card v-else class="ma-0 pa-0" align="center" justify="center" width="100%" :height="virtualScrollerHeight - 4" variant="outlined" :rounded="false">
        <div class="subtitle-2" :style="'width: 100%; height: 100%'">{{ s_DeviceList_NoDevsFound }}</div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { ref, toRaw } from "vue";
import { getString } from "@/js/ChargeStationStatus";
export default {
  props: {
    modelValue: {
      default: null,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    showFilters: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    width: {
      type: [Number, String],
      default: 250,
    },
    height: {
      type: [Number, String],
      default: "100%",
    },
    slotHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lastItem: this.modelValue,
      getString: getString,
      listHeight: false,
      filtersHeight: 40,
      virtualScrollerHeight: 666,
      filterText: "",
      devsSortTypes: [
        { id: 0, name: "Текущо активни", prop: "CurrentlyActive", proptype: Number },
        { id: 1, name: "Мощност ↓", prop: "Power", proptype: Number, asc: true },
        { id: 2, name: "Мощност низходящо ↑", prop: "Power", proptype: Number },
        { id: 3, name: "Оборот ↓", prop: "SumToday", proptype: Number, asc: true },
        { id: 4, name: "Оборот низходящо ↑", prop: "SumToday", proptype: Number },
        { id: 5, name: "Име ↓", prop: "name", proptype: String, asc: true },
        { id: 6, name: "Име ↑", prop: "name", proptype: String },
        { id: 7, name: "Статус ↓", prop: "Status", proptype: Boolean, asc: true },
        { id: 8, name: "Статус ↑", prop: "Status", proptype: Boolean },
        { id: 9, name: "УБ ↓", prop: "fd.sn", proptype: String, asc: true },
        { id: 10, name: "УБ ↑", prop: "fd.sn", proptype: String },
      ],
      devsSortType: "Статус ↓",
      recalcTimeout: null,
      manualClick: true,
      s_SearchSort: "Търсене / филтриране",
      s_AllDevices: "Всички станции",
      s_DeviceList_ChooseAllDevs: "Избор на всички станции",
      s_DeviceList_NoDevsFound: "Не са намерени станции",
    };
  },
  methods: {
    filterChanged() {
      this.$emit("filterChanged", this.filterText ? undefined : this.getItems);
    },
    datesChanged() {
      this.$emit("datesChanged", this.dates);
    },
    itemClick(item) {
      if (item != this.lastItem) {
        this.manualClick = false;
        this.lastItem = toRaw(item);
        this.$emit("stationClick", item);
        this.$emit("update:modelValue", item);
      }
    },
    isSelected(item) {
      return toRaw(this.lastItem) == toRaw(item); // || this.lastItem == item || toRaw(this.lastItem) == item;
    },
    recalcWidthHeight() {
      if (this.recalcTimeout) clearTimeout(this.recalcTimeout);
      this.recalcTimeout = setTimeout(() => {
        if (this.$refs.refDeviceListContainer && this.$refs.refDeviceListContainer.clientHeight > 0) {
          this.virtualScrollerHeight = this.$refs.refDeviceListContainer.clientHeight - 5;
        }
      }, 333);
    },
  },
  computed: {
    wi() {
      return this.width instanceof String || typeof this.width === "string" ? this.width : this.width + "px";
    },
    he() {
      return this.height instanceof String || typeof this.height === "string" ? this.height : this.height + "px";
    },
    maxHeight() {
      return 24 + this.filtersHeight + this.slotHeight + this.getButtonsHeight * (this.items.length + (this.showAll ? 1 : 0)) + "px";
    },
    getButtonsHeight() {
      return 30 + this.IF.Font * 10;
    },
    getItems() {
      // var filterIdx = this.devsFilterTypes.findIndex(f => f.name == this.devsFilterType);
      var sort = this.devsSortTypes.find((st) => st.name == this.devsSortType);
      var data = this.items.filter(
        (i) => !this.filterText || Object.values(i).find((val) => val && val.toString().toLowerCase().contains(this.filterText.toLowerCase()))
      );
      switch (sort.proptype) {
        case Number:
        case Boolean:
          return data.sort((a, b) => {
            var p1 = Object.byString(a, sort.prop);
            var p2 = Object.byString(b, sort.prop);
            if (!p1) return 1;
            if (!p2) return -1;
            return sort.asc ? p1 - p2 : p2 - p1;
          });
        case String:
        default:
          return data.sort((a, b) => {
            var pp1 = Object.byString(a, sort.prop);
            var pp2 = Object.byString(b, sort.prop);
            if (!pp1) return 1;
            if (!pp2) return -1;
            var res = pp1.localeCompare(pp2, "bg", { sensitivity: "base" });

            return sort.asc ? res : -res;
          });
      }
    },
    MyClass() {
      return getString(this.station.Status);
    },
  },
  watch: {
    height: {
      handler() {
        this.recalcWidthHeight();
      },
    },
    slotHeight: {
      handler() {
        this.recalcWidthHeight();
      },
    },
    modelValue: {
      handler() {
        this.lastItem = this.modelValue;
        if (!this.manualClick && this.$refs.refVirtualScroller) {
          var scrlPos = this.getItems.indexOf(this.lastItem) * this.getButtonsHeight;
          this.$refs.refVirtualScroller.$el.scrollTop = scrlPos;
        }
        this.manualClick = true;
      },
      deep: true,
    },
    // lastItem: {
    //   handler() {
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.$nextTick(() => {
      this.recalcWidthHeight();
    });
  },
  setup() {
    const refVirtualScroller = ref(null);
    const refDeviceListContainer = ref(null);
    return { refVirtualScroller, refDeviceListContainer };
  },
};
</script>

<style scoped>
.v-card {
  border-color: gray;
}
</style>